import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IVendorCompanyMast } from "../../../models/VendorCompanyMast";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { Search } from "../../../shared/Search";
import { EmptyVendorCompany } from "./EmptyVendorCompany";
import { IModel } from "./Tender_Client_Mast";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { format } from "date-fns";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { TenderClientAddedPOC } from "./TenderClientAddedPOC";
import { Form } from "../../vendorCompanyMast/Form";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, IFilter } from "./Filter";

interface Iprops {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
}

export const EmptyFilter = {
  client_Category_ID: null,
  service_Department: null
};

export const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVendorCompanyMast>; loading: boolean });
  const [totalRecords, setTotalRecords] = useState(0);
  const [globalFilter, setGlobalFilter] = useState<string | null>(null);
  const [openPOCList, setOpenPOCList] = useState({ open: false, singleData: {} } as { open: boolean; singleData: IVendorCompanyMast });
  const [modal, setModal] = useState({ singleData: EmptyVendorCompany, open: false } as { open: boolean, singleData: IVendorCompanyMast });
  const [reload, setReload] = useState<boolean>(false);
  const [filters, setFilters] = useState<IFilter>(EmptyFilter);
  //   const [openAccout, setOpenAccout] = useState({ open: false, singleData: {} } as { open: boolean; singleData: IVendorCompanyMast });
  //   const [historyTable, setHistoryTable] = useState({ vendor_Company_ID: null, open: false } as { vendor_Company_ID: any; open: boolean });
  //   const [historytableData, setHistorytableData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>; loading: boolean });
  // const dt = useRef<any>(null);
  const [lazyParams, setLazyParams] = useState<ILazyParams>({ first: 0, rows: 25, page: 1, sortField: "vendor_Company_ID", sortOrder: -1 });
  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  useEffect(() => {
    getTableDataCount();
    loadTableData();
  }, [filters, globalFilter, lazyParams, props.reload, reload]);

  const onPage = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  };

  const onSort = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  };

  const getTableDataCount = async () => {
    const response = await Fetch("Tender_Client_Category/count", "GET", null, `filter=${JSON.stringify(filters)}&globalFilter=${globalFilter}`, props.toast);
    if (response) {
      const count: number = parseInt(await response.text(), 10);
      setTotalRecords(count);
    }
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Tender_Client_Category/GetTenderClient", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filters)}&globalFilter=${globalFilter}`, props.toast);
    if (response) {
      const data: Array<IVendorCompanyMast> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyVendorCompany });
  };

  const openEdit = (rowDatauser: IVendorCompanyMast) => {
    rowDatauser.city = {
      city_ID: rowDatauser?.city_ID ? rowDatauser?.city_ID : 0,
      city_Name: rowDatauser?.city_Name ? rowDatauser?.city_Name : "",
    };
    rowDatauser.state = {
      state_ID: rowDatauser?.state_ID ? rowDatauser?.state_ID : 0,
      state_Name: rowDatauser?.state_Name ? rowDatauser?.state_Name : "",
    };

    if (rowDatauser.client_Category_ID === 2) {
      setModal({ open: true, singleData: rowDatauser });
    } else props.setModal({ open: true, singleData: rowDatauser });
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">RFP Client</h5>
      <span className="block mt-2 md:mt-0 p-input-icon-left">
        <Search setSearch={setGlobalFilter} />
      </span>
    </div>
  );

  const website_URL = (rowData: IVendorCompanyMast) => {
    return (
      rowData.website_URL && (
        <a target="_blank" href={rowData.website_URL}>
          {rowData.website_URL}
        </a>
      )
    );
  };

  const actionBodyTemplate = (rowData: IVendorCompanyMast) => {
    return (
      <div className="actions">
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
      </div>
    );
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
      <Accordion activeIndex={0}>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={(filters: IFilter) => setFilters(filters)} loading={tableData.loading} />
        </AccordionTab>
      </Accordion>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
        size="small"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        lazy
        dataKey="id"
        paginator
        first={lazyParams.first}
        rows={lazyParams.rows}
        rowsPerPageOptions={[25, 50, 100, 200]}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        emptyMessage="No Company found."
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        header={header}
        loading={tableData.loading}
      >
        <Column field="vendor_Company_Name" header="Company Name" sortable />
        <Column field="vendor_Company_FidNo" header="FID#" sortable />
        <Column field="vendor_Company_Phone" header="Phone No." />
        <Column field="vendor_Company_FaxNo" header="Fax No." sortable />
        <Column field="client_Category" header="Client Category" sortable />
        {/* <Column field="service_Department" header="Service Department" sortable /> */}
        <Column field="city_Name" header="City" sortable />
        <Column field="state_Name" header="State Name" sortable />
        <Column field="website_URL" header="Website Url" body={website_URL} />
        <Column field="added_By" header="Added By" />
        <Column field="added_On" header="Added At" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} sortable />
        <Column header="POC's" body={(rowData: IVendorCompanyMast) => <span className="cursor-pointer text-cyan-700" onClick={() => { setOpenPOCList({ open: true, singleData: rowData }); }}>POC Added</span>} />
        <Column body={actionBodyTemplate} />
      </DataTable>
      <TenderClientAddedPOC open={openPOCList.open} singleData={openPOCList.singleData} hideDialog={() => setOpenPOCList({ open: false, singleData: { vendor_Type_Name: "" } })} toast={props.toast} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={() => setModal({ open: false, singleData: EmptyVendorCompany })} toast={props.toast} reload={reload} setReload={setReload}></Form>
    </>
  );
};
